var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-table',[_c('tbody',[_c('tr',[_c('th',[_vm._v("Name")]),_c('td',[_vm._v(_vm._s(_vm.data.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }